export default function tel(data) {
  if (data === 'Non renseigné') {
    return data;
  }
  const prefix = data.substr(0, 3);
  if (prefix === '+33') {
    data = 0 + data.slice(3);
  }
  // add spacing after two characters
  data = data.replace(/(.{2})(?=.)/g, '$1 ');
  return data;
}
